import styles from "./index.module.scss";
import downloadImg from "../../../../assets/images/download.png";
// import shareIcon from "../../../../assets/images/share.png";
// import shareLight from "../../../../assets/images/shareLight.png";
// import { isMobileDevice } from "../../../../utils/getPlatformInfo";
// import { useTheme } from "../../../../contexts/ThemeContext/ThemeContext";
import { AnalyticsContext } from "../../../../contexts/Analytics/AnalyticsContextProvider";
import { useContext, useState, useEffect } from "react";
import { RESOURCES_CLICK } from "../../../../AppConstants/AnalyticsEventName";
import { webinarContext } from "../../../../contexts/WebinarContext/WebinarContextProvider";
import { RESOURCE_DOWNLOAD_EVENT } from "../../../../Clevertap/EventNames.ts";

function Resources({ eventdata, resources }) {
  const { getResources } = useContext(webinarContext);
  const [resourcesList, setResourcesList] = useState([]);
  const { addGAWithUserInfo, addCleverTapAnalytics } =
    useContext(AnalyticsContext);
  // const { isDark } = useTheme();

  useEffect(() => {
    if (resources && resources.length > 0) {
      getResourcesList(resources);
    }
  }, [resources]);

  const getResourcesList = (resourcesArr) => {
    let res = getResources(resourcesArr);
    res.then((array) => setResourcesList(array));
  };

  return (
    <div className={styles.resourcesWrapper}>
      {resourcesList.length <= 0 ? (
        <div className={styles.card} style={{ justifyContent: "center" }}>
          No Resources
        </div>
      ) : (
        resourcesList.map((resource, index) => {
          return (
            <div className={styles.card} key={index}>
              <div className={styles.image}>
                <img src={resource.logoUrl} alt={resource.title} />
              </div>
              <div className={styles.info}>
                <div className={styles.title}>{resource.title}</div>
                <div className={styles.subtitle}>{resource.description}</div>
                <div className={styles.actionBtns}>
                  <a
                    href={resource.link}
                    download={resource.title}
                    target="_blank"
                    className={styles.downloadBtn}
                    rel="noreferrer"
                    onClick={() => {
                      addCleverTapAnalytics(RESOURCE_DOWNLOAD_EVENT, {
                        ...eventdata,
                        "Resource Url": resource.link,
                      });
                      addGAWithUserInfo(RESOURCES_CLICK, {
                        eventId: resource.id,
                      });
                    }}
                  >
                    <img src={downloadImg} alt="download" />
                    Download
                  </a>
                  {/* <div className={styles.shareBtn}>
                  <img src={!isDark ? shareLight : shareIcon} alt="share" />
                  {!isMobileDevice && "Share"}
                </div> */}
                </div>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}

export default Resources;
